import React from 'react';
import { View } from 'react-native';
import { useNavigation, useRoute, type RouteProp } from '@react-navigation/native';
import type { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { dynamicTranslations } from '@shared/utils/dynamicTranslation';
import { MainLayout } from '@shared/components/md-design-system/Layout/MainLayout';
import Icon from '@shared/components/md-design-system/Icon/Icon';
import { Head } from '@shared/components/head';
import { Text } from '@shared/components/text';
import Button from '@md-design-system/Button/Button';
import { colorPalette } from '@shared/config/colorsConfig';
import { TDeviceIssueType, TDeviceIssueVerifyOutcome } from 'app/types/deviceIssue';
import { DEVICE_ISSUE_CONFIG, DEVICE_ISSUE_VERIFY_OUTCOME_CONFIG } from '../constants/deviceIssueConfig';

type DeviceTroubleshootingResultParams = {
  issueType: TDeviceIssueType;
  outcome: TDeviceIssueVerifyOutcome;
};
type DeviceTroubleshootingResultRouteProp = RouteProp<Record<string, DeviceTroubleshootingResultParams>, string>;
type DeviceTroubleshootingResultNavigationProp = NativeStackNavigationProp<any>;

export const DeviceTroubleshootingResultScreen = () => {
  const navigation = useNavigation<DeviceTroubleshootingResultNavigationProp>();
  const route = useRoute<DeviceTroubleshootingResultRouteProp>();
  const { issueType, outcome } = route.params;
  const { t } = dynamicTranslations();

  const outcomeCopy = DEVICE_ISSUE_CONFIG[issueType]?.page.verify?.[outcome];
  const outcomeStyle = DEVICE_ISSUE_VERIFY_OUTCOME_CONFIG[outcome];

  const handleBackToHome = () => {
    navigation.navigate('Homepage');
  };

  if (!outcomeCopy || !outcomeStyle) {
    return null;
  }

  const { icon, circleClassName } = outcomeStyle;

  return (
    <MainLayout>
      <View className="flex-1 flex-col justify-between">
        <View className="flex-1 items-center justify-center gap-4">
          <View className={`w-24 h-24 rounded-full items-center justify-center ${circleClassName}`}>
            <Icon name={icon} size={52} color={colorPalette.white} />
          </View>
          <Head type="h2" className="text-center">{t(outcomeCopy.titleKey)}</Head>
          <Text className="text-center text-gray-600">{t(outcomeCopy.descriptionKey)}</Text>
        </View>
        <View className="pt-6">
          <Button variant="primary" size="large" onPress={handleBackToHome}>
            {t('buttons.returnToActivities')}
          </Button>
        </View>
      </View>
    </MainLayout>
  );
};

export default DeviceTroubleshootingResultScreen;
